import * as ng from 'angular';
import {TitleModule} from './title/title.module';
import {ValidFileModule} from './valid-file/valid-file.module';
import {TypeaheadFocusModule} from './typeahead-focus/typehead-focus.module';
import {AutoResizeModule} from './auto-resize/auto-resize.module';
import {FocusMeModule} from './focus-me/focus-me.module';
import {UibDatepickerPopupModule} from './uib-datepicker-popup/uib-datepicker-popup.module';
import {UibDatepickerPopupFormatModule} from './uib-datepicker-popup-format/uib-datepicker-popup-format.module';
import {NumberDecimalModule} from './number-decimal/number-decimal.module';
import {UppercaseModule} from './uppercase/uppercase.module';
import {DropzoneMessageModule} from './dropzone-message/dropzone-message.module';
import {DropzoneBase64Module} from './drop-zone-base64/drop-zone-base64.module';
import {DropzoneModule} from './dropzone/dropzone.module';
import {RepeatDirectiveModule} from './repeat-directive/repeat-directive.module';
import {CompileModule} from './compile/compile.module';
import {NgenterModule} from './ngenter/ngenter.module';
import {ContextMenuModule} from './context-menu/context-menu.module';
import {AddIconBeforePlaceholderModule} from './add-icon-before-placeholder/add-icon-before-placeholder.module';
import {BarChartModule} from './bar-chart/bar-chart.module';
import {
  ContainerBottomReachedOnScrollModule
} from './container-bottom-rached-on-scroll/container-bottom-rached-on-scroll.module';
import {DropboxSaverModule} from './dropbox-saver/dropbox-saver.module';
import {NgDblClickModule} from './ng-dbl-click/ng-dbl-click.module';
import {PdfViewerModule} from './pdf-viewer/pdf-viewer.module';
import {PostRepeatDirectiveModule} from './post-repeat-directive/post-repeat-directive.module';
import {NgPrintModule} from './ng-print/ng-print.module';
import {ValidDateModule} from './validate-date/validate-date.module';

export const DirectivesModule: string =
  ng.module('archismall.directives', [
    TitleModule,
    ValidFileModule,
    TypeaheadFocusModule,
    AutoResizeModule,
    FocusMeModule,
    UibDatepickerPopupModule,
    UibDatepickerPopupFormatModule,
    NumberDecimalModule,
    UppercaseModule,
    DropzoneMessageModule,
    DropzoneBase64Module,
    DropzoneModule,
    RepeatDirectiveModule,
    CompileModule,
    NgenterModule,
    ContextMenuModule,
    AddIconBeforePlaceholderModule,
    BarChartModule,
    ContainerBottomReachedOnScrollModule,
    DropboxSaverModule,
    NgDblClickModule,
    PdfViewerModule,
    PostRepeatDirectiveModule,
    NgPrintModule,
    ValidDateModule
  ])
    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/directives.module.ts